import { render, staticRenderFns } from "./schemesimulation.vue?vue&type=template&id=dfcdcba0&scoped=true&"
import script from "./schemesimulation.vue?vue&type=script&lang=js&"
export * from "./schemesimulation.vue?vue&type=script&lang=js&"
import style0 from "./schemesimulation.vue?vue&type=style&index=0&id=dfcdcba0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcdcba0",
  null
  
)

export default component.exports